import {View} from 'MWC';
import tpl from '../templates/HowToBlock.jsx';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL
        };
        return this;
    }

    static defaultProps = {
        data: [],
        page: '',
        className: '',
        isMobile: false
    };
}
